import { Directive, forwardRef } from '@angular/core';
import { GoogleMapsAddressAutocompleteDirectiveDef } from '@df/module-google-maps/address/autocomplete/google-maps-address-autocomplete.directive.def';
import { GoogleMapsAddressService } from '@df/module-google-maps/address/google-maps-address.service';
import { AddressFieldsetComponentDef } from '@df/ui/form/address-fieldset.component.def';
import { LocalGoogleMapsAddressService } from '../../../module/google-maps/address/local-google-maps-address.service';
import { CustomformAddressFieldsetComponent } from '../address-fieldset/customform-address-fieldset.component';

@Directive({
    selector: '[customform-google-maps-address-autocomplete]',
    standalone: true,
    providers: [
        { provide: AddressFieldsetComponentDef, useExisting: forwardRef(() => CustomformAddressFieldsetComponent) },
        GoogleMapsAddressService,
        { provide: GoogleMapsAddressService, useClass: LocalGoogleMapsAddressService }
    ]
})
export class CustomformGoogleMapsAddressAutocompleteDirective extends GoogleMapsAddressAutocompleteDirectiveDef {}
